export const announcementKeys = {
    active: () => [...announcementKeys.all, 'active'] as const,
    all: ['announcements'] as const,
    history: () => [...announcementKeys.all, 'history'] as const,
} as const;
